import React, {useState} from 'react';
import styles from './SideFlag.module.scss';
import { useTranslation } from 'react-i18next';
import tokenCoin from '../../assets/imgs/tower-token 2.png';
import closeIcon from '../../assets/icons/btn-close-X.svg';
import { Modal } from 'react-bootstrap';
import bonusNFT from '../../assets/imgs/nft_bonus.png';
import { OpenStarChestInfoModal } from '../OpenStarChestInfoModal/OpenStarChestInfoModal';

const SideFlag = (props) => {
    const [t] = useTranslation();
    const [starModal, setStarModal] = useState(false);
    const [rewardModal, setRewardModal] = useState(false);
    const { claimed, daysBonus, nextDaysBonus, countdownTime, claimedAllThisMonth, currentIteration, endOfMonthDate } = props;

    const renderTokenAmount = (
        claimed || claimedAllThisMonth ?
            nextDaysBonus?.value :
            daysBonus?.value
    )

    const renderMapRewards = (
        currentIteration <= 28 ?
            claimed ?
                (nextDaysBonus?.image ?
                    <div className={styles.rewards_maps}>
                        <img src={nextDaysBonus.image} alt="map-rewards" />
                        <div>{nextDaysBonus.name}</div>
                    </div> :
                    "") :
                (daysBonus?.image ?
                    <div className={styles.rewards_maps}>
                        <img src={daysBonus.image} alt="map-rewards" />
                        <div>{daysBonus.name}</div>
                    </div> :
                    "")
            : ""
    )

    return (
        <div className={styles.reward_container}>
                <div className={styles.star_rewards}>
                    <div className={`${styles.reward_banner}
                        ${currentIteration > 28 ? (currentIteration === endOfMonthDate ? styles.crazo_pass_and_attendance_banner : styles.crazo_pass_banner) : ''}
                        ${(claimed || claimedAllThisMonth) && styles.claimed}`}
                    >
                        <div className={styles.rewards_details}>
                            <div className={styles.rewards_container}>
                                <div className={styles.reward_title}>
                                    {claimed || claimedAllThisMonth ? t('NEXT_REWARD') : t('TODAYS_REWARD')}:
                                </div>
                                <div className={styles.rewards}>
                                    {currentIteration > 28 ?
                                        <div className={styles.rewards_tokens}>
                                            {claimed ?
                                                nextDaysBonus?.content || (
                                                    <div className={styles.rewards_tokens}>
                                                        <img src={tokenCoin} alt="Tower Token Coin" />
                                                        <div className={styles.coinNumbers}>+ {nextDaysBonus?.value}</div>
                                                    </div>
                                                ) :
                                                daysBonus?.content    
                                            }
                                        </div> :
                                        currentIteration === 28 && claimed ?
                                            nextDaysBonus?.content || <div className={styles.rewards_tokens}>
                                                <img src={tokenCoin} alt="Tower Token Coin" />
                                                <div className={styles.coinNumbers} style={{ color: `${!claimed ? '#fff' : ''}` }}>+ {renderTokenAmount}</div>
                                            </div>:
                                            <div className={styles.rewards_tokens}>
                                                <img src={tokenCoin} alt="Tower Token Coin" />
                                                <div className={styles.coinNumbers} style={{ color: `${!claimed ? '#fff' : ''}` }}>+ {renderTokenAmount}</div>
                                            </div>
                                    }
                                    
                                    {renderMapRewards}
                                </div>
                            </div>

                            <div className={styles.details_section_m}>
                                <div className={styles.model_open_text}>{t('OPEN_STAR_CHEST_FOR_TOWER')}</div>
                                <div className={styles.details_btns}>
                                    <div className={styles.details_btn} onClick={() => setStarModal(true)}>{t('HOW_TO_OPEN')}</div>
                                    <div className={styles.details_btn} onClick={() => setRewardModal(true)}>{t('REWARDS_DETAILS')}</div>
                                    <div className={styles.modal_target_text}>
                                        <a href="https://medium.com/tower-token/" target="_blank" rel="noopener noreferrer">
                                            {t('EVENT_DETAILS')}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            (claimed || claimedAllThisMonth) &&
                                <div className={styles.come_back_text}>
                                    {t('COME_BACK_AGAIN')}
                                    <div className={styles.time_separator}></div>
                                    <span className={styles.time_text}>&nbsp;
                                        {/* {(claimedAllThisMonth || currentIteration >= 28) && <>{countdownTime?.days}{t('DAY_KEY')}</>} */}
                                        {countdownTime?.hours}{t('HOUR_KEY')} {countdownTime?.minutes}{t('MINUTE_KEY')}</span>
                                </div>
                        }
                        <div className={styles.details_section}>
                            <div className={styles.model_open_text}>{t('OPEN_STAR_CHEST_FOR_TOWER')}</div>
                            <div className={styles.details_btns}>
                                <div className={styles.details_btn} onClick={() => setStarModal(true)}>{t('HOW_TO_OPEN')}</div>
                                <div className={styles.details_btn} onClick={() => setRewardModal(true)}>{t('REWARDS_DETAILS')}</div>
                            </div>
                            <div className={styles.modal_target_text}>
                                <a href="https://medium.com/tower-token/" target="_blank" rel="noopener noreferrer">
                                    {t('EVENT_DETAILS')}
                                </a>
                            </div>
                        </div>
                    </div>
                    <OpenStarChestInfoModal
                        starModal={starModal}
                        setStarModal={setStarModal}
                        title={t('HOW_TO_OPEN_STAR_CHEST')}
                        body={t('EARN_STAR_CHEST_GETTING_STARS_IN_GAME')}
                    />
                    <Modal show={rewardModal} className={styles.reward_modal}  centered contentClassName={styles.reward_modalContent} dialogClassName={styles.reward_modalDialog} onHide={() => setRewardModal(false)}>
                        <button className={styles.close_btn} onClick={()=> setRewardModal(false)}>
                            <img src={closeIcon} alt="" />
                        </button>
                        <Modal.Body bsPrefix={styles.reward_modalBody}>
                            <div className={styles.reward_modalContainer}>
                                <div className={styles.reward_title}>
                                    <h5>{t('OPEN_STAR_CHEST')}</h5>
                                    <h5>{t('YOU_WILL_GET')}</h5>
                                </div>
                                <div className={styles.reward_item}>
                                    <p>{t('FIRST_IN_MONTH')}</p>
                                    <div className={styles.reward_number}>
                                        <img src={tokenCoin} alt="" />
                                        <h5>1</h5>
                                    </div>
                                </div>
                                <div className={styles.reward_item}>
                                    <p>{t('TOTAL_FOUR_DAYS')}</p>
                                    <div className={styles.reward_number}>
                                        <img src={tokenCoin} alt="" />
                                        <h5>10</h5>
                                        <p>(=1+2+3+4)</p>
                                    </div>
                                </div>
                                <div className={styles.reward_item}>
                                    <p>{t('TOTAL_OF_EVERYDAY_IN_A_MONTH')}</p>
                                    <div className={styles.reward_number}>
                                        <img src={tokenCoin} alt="" />
                                        <h5>406</h5>
                                        <p>(=1+2+3…+28)</p>
                                    </div>
                                </div>
                                <div className={styles.bonus_amount_container}>
                                    <p className={styles.amount_info}>
                                        {t('BONUS_NFT_FOR_ACCUMULATED_DAYS')}
                                    </p>
                                    <img src={bonusNFT} alt="bonus-amount-chart" />
                                </div>
                                <div className={styles.detailsBtn}>
                                    <a href="https://medium.com/tower-token/"  target="_blank" rel="noopener noreferrer">
                                        {t('LEARN_MORE')}
                                    </a>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
        </div>
    )
}

export { SideFlag }
